<template>
  <div class="main">
    <div class="header">
      <a-select
        class="select"
        default-value="所有类型"
        @change="showModelTypeChange"
        size="small"
      >
        <a-select-option value="所有类型">所有类型</a-select-option>
        <a-select-option v-for="t in modelType" :key="t.type" :value="t.type">{{
          t.type
        }}</a-select-option>
      </a-select>
      <a-select
        class="select"
        default-value="上传时间-降"
        @change="sortModel"
        size="small"
      >
        <a-select-option value="上传时间-降">上传时间-降</a-select-option>
        <a-select-option value="上传时间-升">上传时间-升</a-select-option>
      </a-select>
      <a-input-search
        class="search"
        size="small"
        type="primary"
        placeholder="请输入模型名称"
        enter-button
        @search="onSearch"
      />
      <a @click="myClick">
        <img
          :src="require('@/assets/my.png')"
          style="height: 24px; width: 24px"
        />
      </a>
    </div>

    <div class="listbody">
      <a-empty v-if="toShowModels.length == 0" :description="emptyMessage" />
      <div v-for="m in toShowModels" :key="m.id" class="productList-item">
        <a-card>
          <img
            class="productList-img"
            slot="cover"
            alt="item"
            :src="'./model/show/' + m.coverPath"
            style="padding: 4px"
            @click="imgClick(m)"
          />
          <a-card-meta
            class="discrition"
            :title="m.name"
            :description="
              m.remark ? m.remark.replace(/\<br\/>/g, '') : '该模型暂无相关说明'
            "
          ></a-card-meta>
        </a-card>
      </div>
    </div>
    <a-drawer
      title="我的"
      placement="right"
      :visible="loginModel.myIsVisiable"
      @close="onMyClose"
    >
      <div v-if="loginModel.loginFormVisible">
        <a-form-model v-model="loginModel">
          <a-form-model-item label="用户名">
            <a-input
              v-model="loginModel.user.nicName"
              placeholder="请输入用户名"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="密码">
            <a-input
              v-model="loginModel.user.password"
              placeholder="请输入密码"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="login">登录</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div v-if="loginModel.myInfoVisible">
        <div class="myBasic">
          <img
            :src="require('@/assets/my.png')"
            style="width: 56px; height: 56px"
          />
          <div>
            <div style="display: flex; justify-content: center">
              <p style="font-size: 16px; height: 18px">用户名：</p>
              <p style="font-size: 16px; height: 18px">
                {{ loginModel.user.nicName }}
              </p>
            </div>
            <div style="display: flex">
              <p style="font-size: 16px">id：</p>
              <p style="font-size: 16px">{{ loginModel.user.id }}</p>
            </div>
          </div>
        </div>
        <a-divider />
        <div style="display: flex; justify-content: center">
          <p style="font-size: 16px; height: 18px">作品数量：</p>
          <p style="font-size: 16px; height: 18px">
            {{ loginModel.uploadCount }}
          </p>
        </div>
        <a-divider />
        <div style="display: flex; justify-content: center">
          <p style="font-size: 16px; height: 18px">只展示我的作品：</p>
          <a-switch
            v-model="showMyModelsOnly"
            @change="showMyModelOnlyChage"
          ></a-switch>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button type="primary" @click="onMySubmit"> 确定 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { UserManager } from "../../../js/tool/UserManager";
import { Server } from "../../../js/Server/Server";
export default {
  name: "MoblieModelList",
  data() {
    return {
      server: new Server(),
      logined: false,
      isForward: true,
      modelType: [],
      curentType: "所有类型",
      emptyMessage: "暂无数据，请上传模型！",
      search: {
        value: "",
      },
      loginModel: {
        myIsVisiable: false,
        loginFormVisible: false,
        myInfoVisible: true,
        uploadCount: 0,
        user: {
          id: "",
          nicName: "",
          password: "",
        },
      },
      showMyModelsOnly: false,
      toShowModels: [],
      allmodels: [],
      publicModels: [],
      mymodels: [],
      tempModels: [],
      searching: false,
      //threejs相关变量
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      color: "",
      userManager: new UserManager(),
    };
  },
  mounted() {
    document.title = "大筑web3d展示平台";
    this.getModelType();
    this.userManager.checkIsLogined(this.checkIsloginedCallBack);
  },
  methods: {
    checkIsloginedCallBack(data) {
      if (data.state == "success") {
        this.logined = true;
        this.loginModel.user = data.data;
        this.loginModel.loginFormVisible = false;
        this.loginModel.myInfoVisible = true;
        this.server.modelByUser(
          this.loginModel.user.id,
          this.getModelByUserCallBack
        );
        this.server.modelNotMineAndPublic(
          this.loginModel.user.id,
          this.getModelNotMineAndPublicCallBack
        );
      } else {
        this.logined = false;
        this.loginModel.loginFormVisible = true;
        this.loginModel.myInfoVisible = false;
        this.server.modelPublic(this.getModelPublicCallback);
      }
    },
    onSearch(val) {
      this.search.value = val;
      if (!this.searching) {
        this.tempModels = this.toShowModels;
      }
      if (this.search.value == "" || this.search.value == null) {
        this.toShowModels = this.tempModels;
        this.searching = false;
      } else {
        this.searching = true;
        var models = [];
        console.log(this.toShowModels);
        this.tempModels.forEach((element) => {
          console.log(element);
          if (
            element.name
              .toUpperCase()
              .indexOf(this.search.value.toUpperCase()) != -1
          ) {
            models.push(element);
          }
        });
        this.toShowModels = models;
        console.log(models);
      }
    },
    getModelType() {
      this.axios.post("./model/getModelType").then((res) => {
        this.modelType = res.data || [];
      });
    },
    list() {
      this.axios.post("./model/list", this.search).then((res) => {
        this.allmodels = res.data || [];
      });
    },
    //暂时使用来校正boolean值
    makeToBoolean(values) {
      var ms = values;
      for (var m of ms) {
        if (m.enableView == "true") {
          m.enableView = true;
        } else {
          m.enableView = false;
        }
        if (m.needPassword == "true") {
          m.needPassword = true;
        } else {
          m.needPassword = false;
        }
      }
      return ms;
    },
    sortModel(value) {
      if (value == "上传时间-升" && this.isForward) {
        this.toShowModels.reverse();
        this.isForward = false;
      } else {
        this.toShowModels.reverse();
        this.isForward = false;
      }
    },
    showModelTypeChange(value) {
      this.curentType = value;
      if(this.showMyModelsOnly){
        this.getShowModel(this.mymodels);
      }else{
        this.getShowModel(this.allmodels);
      }
    },
    needPasswordValueChange(checked) {
      this.mod.needPassword = checked;
    },
    enableViewValueChage(checked) {
      this.mod.enableView = checked;
    },
    //校验管理密码
    login() {
      if (
        this.loginModel.user.password != "" &&
        this.loginModel.user.nicName != ""
      ) {
        this.axios.post("./user/login", this.loginModel.user).then((res) => {
          this.loginModel.user = res.data;
          if (this.loginModel.user.id) {
            this.$message.success("校验成功！");
            this.loginModel.can = true;
            this.loginModel.show = false;
            this.logined = true;
            this.userManager.setCookie(
              this.loginModel.user.id,
              this.loginModel.user.password,
              30
            );
            this.loginModel.loginFormVisible = false;
            this.loginModel.myInfoVisible = true;
            this.server.modelByUser(
              this.loginModel.user.id,
              this.getModelByUserCallBack
            );
            this.server.modelNotMineAndPublic(
              this.loginModel.user.id,
              this.getModelNotMineAndPublicCallBack
            );
          } else {
            this.$message.error("校验管理密码失败，请重试或联系管理员！");
          }
        });
      } else {
        this.$message.error("请输入管理密码！");
      }
    },

    imgClick(model) {
      let routeData = this.$router.resolve({
        name: "m_Model",
        params: { id: model.id },
        query: { id: model.id },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({
      //   name: "Model",
      //   params: { id: model.id },
      //   query: { id: model.id },
      // });
    },
    myClick() {
      this.loginModel.myIsVisiable = true;
      if (this.logined) {
        this.loginModel.loginFormVisible = false;
        this.loginModel.myInfoVisible = true;
      } else {
        this.loginModel.loginFormVisible = true;
        this.loginModel.myInfoVisible = false;
      }
    },
    onMyClose() {
      this.loginModel.myIsVisiable = false;
    },
    onMySubmit() {
      this.loginModel.myIsVisiable = false;
    },

    collectMyModels() {
      this.mymodels = [];
      for (var m of this.allmodels) {
        if (m.userID == this.loginModel.user.id) {
          this.mymodels.push(m);
        }
      }
      this.loginModel.uploadCount = this.mymodels.length;
    },
    getModelPublicCallback(models) {
      this.allmodels = this.makeToBoolean(models);
      this.toShowModels = this.allmodels;
    },
    getModelByUserCallBack(models) {
      this.mymodels = this.makeToBoolean(models);
      this.allmodels = this.mymodels.concat(this.publicModels);
      if (this.showMyModelsOnly) {
        this.toShowModels = this.mymodels;
      } else {
        this.toShowModels = this.allmodels;
      }
    },
    getModelNotMineAndPublicCallBack(models) {
      this.publicModels = this.makeToBoolean(models);
      this.allmodels = this.mymodels.concat(this.publicModels);
      if (this.showMyModelsOnly) {
        this.toShowModels = this.mymodels;
      } else {
        this.toShowModels = this.allmodels;
      }
    },
    showMyModelOnlyChage(v) {
      if (v) {
         this.getShowModel(this.mymodels);
        } else {
          this.getShowModel(this.allmodels);
        }
    },
    getShowModel(models) {
      var newModels = [];
      if (this.curentType == "所有类型") {
        newModels=models;
      } else {
        for (var m of models) {
          if (m.modelType == this.curentType) {
            newModels.push(m);
          }
        }
      }
       this.toShowModels=newModels;
    },
  },
};
</script>

<style scoped>
.header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.select {
  font-size: 12px;
  width: 80px;
}

.search {
  font-size: 12px;
  width: 100px;
}
.listbody {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.productList-item {
  width: 150px;
  margin: 2px 2px 2px 2px;
  background: rgb(255, 255, 255);
}
.productList-img {
  width: 150px;
  height: 170px;
  margin: 2px auto;
  object-fit: cover;
}

.discrition {
  height: 40px;
  overflow: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.myBasic {
  display: flex;
  justify-content: space-around;
}
</style>
